import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Constants
import countries from "./countries";
var locales = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, countries.AT, 'at-AT'), countries.EN, 'en-GB'), countries.ES, 'es-ES'), countries.DE, 'de-DE'), countries.NL, 'nl-NL'), "CH", 'ch-CH'), "LI", 'li-LI');
export default locales;